import classNames from 'classnames';
import { BookIcon, HomeIcon, PeopleMenuIcon, StreeningIcon, TextBlockIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { globalConst } from 'modules/global';

const MobileFooterMenu = () => {
  const { locale = 'ru', pathname } = useRouter();
  const t = globalConst.extraTranslation.header[locale as 'uz' | 'ru'];

  const menuItems = [
    { label: t.bosh_sahifa, href: '/', icon: <HomeIcon /> },
    { label: t.mavzuli_test, href: globalConst.pageNames.TOPIC_TEST, icon: <BookIcon /> },
    { label: t.blok_test, href: globalConst.pageNames.BLOCK_TEST, icon: <TextBlockIcon /> },
    {
      label: t.avto_test,
      href: globalConst.pageNames.AUTO_TEST,
      icon: <StreeningIcon className='size-6' />
    },
    { label: t.oliygohlar, href: globalConst.pageNames.UNIVERSITIES, icon: <PeopleMenuIcon /> }
  ];

  return (
    <div className="h-19 fixed bottom-0 left-0 z-[101] grid w-full grid-cols-5 items-center gap-2 border border-solid border-[#EAECF0] bg-white px-2 md:hidden">
      {menuItems?.map(item => {
        const isActive = item.href === '/' ? pathname === '/' : pathname.startsWith(item.href);

        return (
          <Link
            key={item?.label}
            className="flex flex-col items-center gap-1 text-gray-500 hover:text-green-600"
            href={item.href}
          >
            <div
              className={classNames('flex items-center justify-center', {
                'text-green-600': isActive
              })}
            >
              {item?.icon}
            </div>
            <p
              className={classNames('line-clamp-1 text-xs font-medium text-gray-500', {
                'text-green-500': isActive
              })}
            >
              {item?.label}
            </p>
          </Link>
        );
      })}
    </div>
  );
};

export default MobileFooterMenu;
